import { HUB_TYPES } from './hubRoutes';

export function buildPmOrganizationGroups(organizations) {
    const rows = Array.isArray(organizations) ? organizations : [];

    return rows
        .filter((org) => org.organization_type === HUB_TYPES.PROJECT_MANAGEMENT)
        .map((parent) => ({
            parent,
            managed: (parent.managed_organizations || []).filter(
                (child) => child.organization_type === HUB_TYPES.PROJECT_MANAGEMENT,
            ),
        }));
}

export function flattenPmOrganizations(groups) {
    const all = [];
    groups.forEach(({ parent, managed }) => {
        all.push(parent);
        managed.forEach((child) => all.push(child));
    });
    return all;
}
